module.exports = __webpack_public_path__ + "0e429c872c9aad8396452f0377ad0f7c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/prologis_2023_chart.png
// module id = 1712
// module chunks = 0